import React from 'react';

import { GET_PROJECT_getProject_genres } from '../../graphql/types/GET_PROJECT';
import { projectGenreOptions } from './Forms/constants';

interface IGenreTagsProps {
  genres: GET_PROJECT_getProject_genres[];
}

const ProjectTags = ({ genres }: IGenreTagsProps) => {
  if (genres.length === 0) return null;

  return (
    <>
      {genres.map((genre) => (
        <span key={genre.id} className="post-card-genre-tag">
          {
            projectGenreOptions.find(
              (genreOpt: { value: string }) => genreOpt.value === genre.name
            )?.label ?? genre.name
          }
        </span>
      ))}
    </>
  );
};

export default ProjectTags;
